import { hasSignedRequest, token } from '@/lib/signed-request';
import { isNullOrUndefined } from 'shared/lib/object/object';

const REQUEST_ID_HEADER = 'x-request-id';
const INSTANCE_ID_HEADER = 'x-instance-id';
const BAGGAGE_HEADER = 'baggage';
const TENANT_ID_HEADER = 'x-tenant-id';

// Generate instance ID once per page load
const generateID = () => btoa([...Array(2).keys()].map(() => Math.random() * Number.MAX_SAFE_INTEGER));
export const instanceId = generateID();

export const installRequestID = (config) => {
  const requestId = generateID();
  let baggage = `lagoon.requestId=${requestId},lagoon.instanceId=${instanceId}`;
  try {
    const baggageHeader = config.headers.get(BAGGAGE_HEADER);
    baggage = baggageHeader ? `${baggageHeader},${baggage}` : baggage;
  } catch (error) { /* empty */ }

  return {
    ...config,
    headers: {
      ...config.headers,
      [`${REQUEST_ID_HEADER}`]: requestId,
      [`${INSTANCE_ID_HEADER}`]: instanceId,
      [`${BAGGAGE_HEADER}`]: baggage,
    },
  };
};

export const installTenantID = (store) => (config) => {
  const tenantId = store.getters?.loggedInUserAccount?.uid;
  if (isNullOrUndefined(tenantId)) {
    return config;
  }
  return {
    ...config,
    headers: {
      ...config.headers,
      [`${TENANT_ID_HEADER}`]: String(tenantId),
    },
  };
};

export const installSignedRequestAuth = (config) => {
  const url = `${config.baseURL}${config.url}`;
  if (!hasSignedRequest(window.location.hash, url)) {
    return config;
  }
  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${token(window.location.hash, url)}`,
    },
  };
};
